import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container profile" }
const _hoisted_2 = { class: "flex flex-wrap justify-content-center profile-header gap-2 pt-4" }
const _hoisted_3 = { class: "flex flex-wrap justify-content-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "lead text-muted" }
const _hoisted_7 = { class: "lead text-muted" }
const _hoisted_8 = { class: "lead text-muted" }

import { useAuth0 } from '@auth0/auth0-vue';
import { ref } from "@vue/reactivity";
import { onBeforeMount } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const storeid = ref('');
const storename = ref('');
const role = ref('');
const { user } = useAuth0();
const store = useStore();

onBeforeMount(() => {
  storeid.value = store.state.storeid;
  storename.value = store.state.storename;
  role.value = store.state.role;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(user)?.picture,
          alt: "User's profile picture",
          class: "border-circle img-fluid profile-picture"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_unref(user)?.name), 1),
        _createElementVNode("p", _hoisted_6, "Email: " + _toDisplayString(_unref(user)?.email), 1),
        _createElementVNode("p", _hoisted_7, "Store name: " + _toDisplayString(_unref(storename)), 1),
        _createElementVNode("p", _hoisted_8, "User role: " + _toDisplayString(_unref(role)), 1)
      ])
    ])
  ]))
}
}

})